import { JSX } from "react";

const ProvidersByZipCodeDescription = (): JSX.Element => {
  return <>
    <p>
      The Providers By Zip Code card summarizes how your network is spread geographically at the Zip Code level. This view of the geographic footprint helps quickly identify where providers are concentrated and where there may be a limited network presence across various Zip Codes.
    </p>
    <p>
      Providers without a valid Zip Code value will be grouped as “Unknown.” 
    </p>
  </>;
}

export { ProvidersByZipCodeDescription };